import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/techtest/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{row.number}/{row.year}</a>;
		};
		const rendererFiles = (val, row) => {
			const files = row.files.map(file => {
				const tooltip = <Tooltip id="file">{file.title}</Tooltip>
				return (
					<OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
						<a style={{color:'#000'}} href={'/file/download/' + file.id}>
							<i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />
						</a>
					</OverlayTrigger>
				)
			});
			return <div>
				{files}
			</div>
		};

		this.columnModel = [
			{
				name: 'number',
				title: 'Protokol',
				field: 'number',
				width: 90,
				renderer: rendererLink
			},
			{
				name: 'date',
				title: 'Datum',
				field: 'date',
				renderer: Renderers.Date
			},
			{
				name: 'cTitle',
				title: 'Firma',
				field: 'cTitle'
			},
			{
				name: 'vId',
				title: 'Vozík',
				field: 'vId',
				renderer: (val, row) => {
					const arr = [];
					arr.push('ev. č. ' + val);
					if (row.make) {
						arr.push(row.make);
					}
					if (row.model) {
						arr.push(row.model);
					}
					return arr.join(' / ');
				}
			},
			 {
				name: 'vEid',
				title: 'Podnik. č.',
				field: 'vEid',
				width: 120,
				viewport: 'tablet'
			},
			{
				name: 'rating',
				title: 'Hodnocení',
				field: 'rating',
				renderer: Renderers.DbInfo.bind(DbInfo.Rating)
			},
			{
				name: 'doc_to',
				title: 'Platnost protokolu',
				field: 'doc_to',
				width: 85,
				renderer: Renderers.Date
			},
			{
				name: 'date_to',
				title: 'Platnost vozíku',
				width: 85,
				field: 'date_to',
				renderer: Renderers.Date
			},
			{
				name: 'files',
				width: 58,
				title: <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />,
				sortable:false,
				renderer: rendererFiles
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/techtest/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			number: { class: FilterInput },
			fulltext: { class: SearchInput },
			cTitle: { class: FilterInput },
			vEid: { class: FilterInput },
			vId: { class: FilterInput },
			rating: { class: Select, options: DbInfo.Rating },
			date: { class: DateRange },
			date_to: { class: DateRange },
			doc_to: { class: DateRange },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
        this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-techtest');
        // default
        let filter = {};
        // session
        if (sessionState && sessionState.filter) {
            filter = sessionState.filter;
        }
        this.defaultFilter = filter;
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'desc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('techtest.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('techtest.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('techtest', row.title, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href="/techtest/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nová prohlídka
		</Button>;


		return (
			<Datagrid
				ref="datagrid"
				id="techtest"
				api="techtest.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Techtest/List.js